import { ReactComponentElement, useEffect } from "react";
import { useSelector } from "react-redux";
import { matchPath, useHistory, useLocation } from "react-router-dom";

import { isSignedIn as getIsSignedIn } from "seneca-common/features/user/state";

import { linkToAnonymousCourseDiscoveryPage } from "features/anonymous-pages/course-discovery/links";
import SignedInRoute from "features/common/routing/SignedInRoute";
import useRedirectToLoginSchool from "features/sign-up/login-school/hooks/useRedirectToLoginSchool";

import { linkToAddCoursesPage } from "../pages/courses-page/links";

type Props = {
  children: ReactComponentElement<any, any>;
};

export default function DashboardRoute({ children }: Props) {
  const isSignedIn = useSelector(getIsSignedIn);
  const history = useHistory();
  const location = useLocation();

  useRedirectToLoginSchool();

  useEffect(() => {
    if (!isSignedIn) {
      if (
        matchPath(location.pathname, {
          path: linkToAddCoursesPage(),
          exact: false
        })
      ) {
        const queryParams = location.search;

        history.replace(linkToAnonymousCourseDiscoveryPage() + queryParams);
      }
    }
  }, [isSignedIn, history, location]);

  return <SignedInRoute>{children}</SignedInRoute>;
}
